import { PresentData } from '../alerts/alerts.service';

export class LoggedAreaTokenExpiredError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'LoggedAreaTokenExpiredError';
  }

  static getAlertData(): PresentData {
    return {
      mainTitle: 'Atenção!',
      icon: 'clock',
      title: 'Acesso Expirado!',
      description:
        '(ERRO 419) <br> Sua sessão expirou devido à inatividade. Por favor, faça o login novamente.',
      titleButtonOk: 'Acessar',
    };
  }
}
